import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AdmService } from 'src/app/service/adm.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SystemService } from 'src/app/service/system.service';
import { UserService } from 'src/app/service/user.service';
import { Globals } from 'src/app/globals';
@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit {

  changePasswordValid: boolean = false;
  confirmPasswordMsg = "";
  showLoader = false;
  userName:any;

  changePasswordForm = new FormGroup({
    newPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(255),
    ]),
    confirmNewPassword: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(private toastr: ToastrService,public translate: TranslateService
    , private userService: UserService,  private router: Router,public global:Globals,
    public activatedRoute :ActivatedRoute) {
    this.changePasswordFormChange();

    // this.toastr.success("Password changed successfully");

  }

  ngOnInit(): void {
    this.activatedRoute
    .queryParams
    .subscribe(params => {
      this.userName = params['email'] ;
    });
  }

  changePasswordFormChange() {
    console.log("newPass : "+this.changePasswordForm.get('newPassword')?.value);
    console.log("newPass : "+this.changePasswordForm.get('confirmNewPassword')?.value);
    this.changePasswordForm.valueChanges.subscribe(val => {
      if (this.changePasswordForm.valid) {

        let newPass = this.changePasswordForm.get('newPassword')?.value;
        let conNewPass = this.changePasswordForm.get('confirmNewPassword')?.value;
        console.log("newPass : "+newPass);
        console.log("conNewPass : "+conNewPass);

        if (newPass == conNewPass) {
          this.confirmPasswordMsg = "";
          this.changePasswordValid = true;
          this.changePasswordForm.controls['confirmNewPassword'].setErrors(null);
        }
        else {
          this.confirmPasswordMsg = "Passwords do not match";
          this.changePasswordValid = false;
          this.changePasswordForm.controls['confirmNewPassword'].setErrors({ incorrect: true });
        }
      }
      else {
        this.changePasswordValid = false;
      }
    });
  }

  changePasswordFormSubmit() {
    this.showLoader = true;
    this.userService.createPass(this.userName,this.changePasswordForm.get('newPassword')?.value).subscribe(
      data => {
        this.router.navigate(['/login']);
          this.toastr.success(this.translate.instant('updated successfully'));
        },
      error => {
          this.toastr.error(this.translate.instant('CAN_NOT_UPDATE'));
      },
      
    );
  }

}
